module.exports = __webpack_public_path__ + "img/right-secretary.46868562.png";